//Gets the positions of the nodes in the graph
function getResourceNodePositions(params, resourceGroups){
    var positionMapper = {"circle": getCirclePositions, "lineair": getLinearPositions};
    var graphPositions = positionMapper[params.graphShape](params, resourceGroups);
    return graphPositions;
}

function getProjectNodePositions(params){
    var dx= 500;
    positions = [];

    if(params.graphShape == "circle"){
        positions.push({x: -dx, y: -300, id:"input", connections: "I"});
        positions.push({x: dx, y: -300, id:"output",  connections: "I"});
    }

    if(params.graphShape == "lineair"){
        positions.push({x: -dx, y: 0, id:"input", connections: "I"});
        positions.push({x: dx, y: 0, id:"output",  connections: "B"});
    }

    return positions;

}

function getLinearPositions(params, resourceGroups){
    var positions = {};

    //Get the Waiting time Shape from the parameters
    var waitingTimeShape = params.shape;
    
    // Iterate through the params.graphParams
    var graphParams = params.graphParams;
    var numColumns = graphParams.length + 2;

    var startHeight = 0;
    var startWidth = -350;
    var heightOffset = 200;
    var widthOffset = 175;



    for(var i = 0; i < graphParams.length; i++){
        var columnNodes = graphParams[i].split("");
        
        // Iterate through the columnNodes and calculate their positions
        for(var j = 0; j < columnNodes.length; j++){
            var id = columnNodes[j];
            var index = resourceGroups.findIndex(x => x.id == id);
            var x = startWidth + i * widthOffset;
            var y = startHeight +  Math.round(j - columnNodes.length/2) *heightOffset;
            var color = resourceGroups[index].color;
            var name = resourceGroups[index].name;


            //Connections to the nodes in the next column
            var connections = [];

            if(i < graphParams.length - 1){
                var nextColumnNodes = graphParams[i + 1].split("");
                for(var k = 0; k < nextColumnNodes.length; k++){
                    connections.push(nextColumnNodes[k]);
                }
            }

            positions[id] = {x: x, y: y, id: id, color: color, name: name, connections: connections};
        }
    }

    return positions;
}

//Get the positions along the circle, for now some hardcoded values
function getCirclePositions(params, resourceGroups) {
    var positions = {};
    var resourceGroupKeys = Object.keys(resourceGroups);
    
    var num = resourceGroups.length;
    var radius = 300;
    var angle = 360 / num;
    var offset = Math.PI / 2 + 3 * Math.PI / num;
    
    for (var i = 0; i < num; i++) {
      var temp = (angle * i * Math.PI) / 180 + offset;
      var x = radius * Math.cos(temp);
      var y = radius * Math.sin(temp);
      var id = resourceGroups[i].id;
      var color = resourceGroups[i].color;
      var name = resourceGroups[i].name;

      //Connections to all except itself
        var connections = resourceGroupKeys.filter(x => x != id);
    
      positions[id] = { x: x, y: y, id: id, color: color, name: name, connections: connections };
    }

    return positions;
}

module.exports = { getResourceNodePositions, getProjectNodePositions}